import abstractModel from '../../core/ShopModel';

const resource = 'retailers/sales_channels';

const model = abstractModel(resource);

export default model;
